/**
 * @description Сохранить запрос расписания.
 * @type {string}
 */
export const STORE_SCHEDULE_QUERY = 'SCHEDULE_QUERY';
/**
 * @description Сохранить параметры.
 * @type {string}
 */
export const STORE_PARAMS = 'STORE_PARAMS_QUERY';

/**
 * @description Очистить запрос расписания.
 * @type {string}
 */
export const CLEAR_SCHEDULE_QUERY = 'CLEAR_SCHEDULE_QUERY';

export default STORE_SCHEDULE_QUERY;
